// @ts-nocheck
import React from "react";
import { FC } from "react";
import { useCallback } from "react";
import { useMemo } from "react";
import { Form } from "react-final-form";
import { FORM_ERROR } from "final-form";
import { useQuery } from "react-query";
import { useSnackbar } from "notistack";
import { makeStyles } from "@material-ui/core";
import { Theme } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { mutateErrors } from "../../../../../utils";
import useUserQueries from "../../../hooks/useUserQueries";
import { useUserAccount } from "../../context";
import SchoolProfileForm from "./SchoolProfileForm";
import SchoolRoleForm from "./SchoolRoleForm";
import SchoolProfileShow from "./SchoolProfileShow";
import { validateSchoolProfileRoleForm } from "./validators";

const useStyles = makeStyles((theme: Theme) => ({
  widget: {
    marginBottom: theme.spacing(4),
  },
  cardContent: {
    paddingBottom: "0!important",
  },
}));

const Profile: FC = () => {
  const classes = useStyles();

  const {
    user,
    profile: {
      refetch,
      data: { data: profile },
    },
  } = useUserAccount();

  const {
    fetchAssignToSchool,
    fetchUpdateSchoolRole,
    fetchAssignedBranches,
    fetchAssignedDegrees,
  } = useUserQueries();

  const { enqueueSnackbar } = useSnackbar();

  const handleChangeSchool = useCallback(
    async (data) => {
      try {
        await fetchAssignToSchool(user.id, data);
        enqueueSnackbar("Success", { variant: "success" });
        refetch();
      } catch (e) {
        const { errors, message } = mutateErrors(e);
        enqueueSnackbar(message, { variant: "error" });
        return { [FORM_ERROR]: message, ...errors };
      }
    },
    [user, fetchAssignToSchool],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  const handleChangeRole = useCallback(
    async (data) => {
      try {
        await fetchUpdateSchoolRole(user.id, data);
        enqueueSnackbar("Success", { variant: "success" });
      } catch (e) {
        const { errors, message } = mutateErrors(e);
        enqueueSnackbar(message, { variant: "error" });
        return { [FORM_ERROR]: message, ...errors };
      }
    },
    [profile],
  ); // eslint-disable-line react-hooks/exhaustive-deps

  const { data: branches } = useQuery<any>(`user_${user.id}_branches`, () =>
    fetchAssignedBranches(user.id),
  );
  const { data: degrees } = useQuery<any>(`user_${user.id}_degrees`, () =>
    fetchAssignedDegrees(user.id),
  );

  const roles = useMemo(
    () => [
      {
        id: 0,
        name: "Admin",
      },
      {
        id: 1,
        name: "Manager",
      },
    ],
    [],
  );

  const profileInitialValues = useMemo(
    () => ({ school: profile.school }),
    [profile],
  );
  const roleInitialValues = useMemo(
    () => ({
      role: roles.find((item) => item.id === profile.role),
      branches: branches ? branches.data : [],
      degrees: degrees ? degrees.data : [],
    }),
    [profile, roles, branches, degrees],
  );

  return (
    <div>
      <div className={classes.widget}>
        <Card>
          <CardHeader
            title={"School"}
            titleTypographyProps={{ variant: "h4" }}
          />
          <CardContent className={classes.cardContent}>
            {profile.school ? (
              <SchoolProfileShow school={profile.school} />
            ) : (
              <Form
                onSubmit={handleChangeSchool}
                initialValues={profileInitialValues}
                component={SchoolProfileForm}
              />
            )}
          </CardContent>
        </Card>
      </div>
      <div className={classes.widget}>
        <Card>
          <CardHeader title={"Role"} titleTypographyProps={{ variant: "h4" }} />
          <CardContent className={classes.cardContent}>
            <Form
              onSubmit={handleChangeRole}
              validate={validateSchoolProfileRoleForm}
              initialValues={roleInitialValues}
              component={SchoolRoleForm}
            />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default React.memo(Profile);
